import React, { useEffect, useState, useContext } from "react";
import { getPackageRatesList } from "../../Services/Packages.service";
import { CalendarViewFunctions } from "../PackageRates/Components/CalendarViewFunctions";
import PackageRateCalendar from "../PackageRates/PackageRateCalendar";
import { showAlert } from "../../Services/Shared.service";
import SharedDataContext from "../../_helper/SharedData";
import { getRatesList } from "../../Services/Rates.service";
import RateCalendar from "../Rates/RateCalendar";
import { endOfMonth, startOfMonth } from "date-fns";
const calendarViewFunctions = new CalendarViewFunctions();

function RateCalendarByCity({ serviceCityId }) {
  const { cityData, globalCityField, setShowApiLoader, airportData } =
    useContext(SharedDataContext);
  const [tableData, setTableData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [paginationTotalRows, setPaginationTotalRows] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const [editId, setEditId] = useState("");
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 30,
  });
  const [isToggled, setIsToggled] = useState(false);
  const [calendarData, setCalendarData] = useState([]);
  const [tableHeaders, setTableHeaders] = useState([]);

  const onChangePage = (page) => {
    console.log("page", page);
    setPagination({
      ...pagination,
      pageIndex: page - 1,
    });
  };

  const onChangeRowsPerPage = (currentRowsPerPage) => {
    setPagination({
      ...pagination,
      pageSize: currentRowsPerPage,
    });
  };

  useEffect(() => {
    fetchTableData(serviceCityId);
  }, [serviceCityId]);

  const fetchTableData = (serviceCityId) => {
    let obj = {
      serviceCityId: serviceCityId ? serviceCityId : null,
      page: pagination.pageIndex,
      size: pagination.pageSize,
    };
    setLoader(true);
    getRatesList(obj)
      .then(async (result) => {
        setPaginationTotalRows(result.data.count);
        console.log("result is ", result);
        setTableData(result.data.list);
        console.log("rates data is", tableData);
        setCalendarData(
          await calendarViewFunctions.getCalendarData(
            result.data.list,
            onEditClick,
            false,
            startOfMonth(new Date()),
            endOfMonth(new Date())
          )
        );
        setTableHeaders(
          await calendarViewFunctions.getTableHeader(
            startOfMonth(new Date()),
            endOfMonth(new Date())
          )
        );
        disableLoaders();
      })
      .catch((err) => {
        // disableLoaders();
        showAlert(
          "error",
          err.response?.data?.message
            ? err.response.data.message
            : "Something went wrong"
        );
      });
  };
  const disableLoaders = () => {
    setLoader(false);
    // setShowApiLoader(false);
  };

  const onEditClick = (element) => {
    setEditId(element.id);
    setIsOpen(true);
  };

  console.log("calendar data", calendarData);

  return (
    <div>
      <RateCalendar
        ratesData={tableData}
        calendarData={calendarData}
        setCalendarData={setCalendarData}
        tableHeaders={tableHeaders}
        setTableHeaders={setTableHeaders}
        pagination={pagination}
        setPagination={setPagination}
        paginationTotalRows={paginationTotalRows}
        onEditClick={onEditClick}
        loader={loader}
      />
    </div>
  );
}

export default RateCalendarByCity;
